import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=aca64850&scoped=true"
import script from "./NewCard.vue?vue&type=script&lang=js"
export * from "./NewCard.vue?vue&type=script&lang=js"
import style0 from "./NewCard.vue?vue&type=style&index=0&id=aca64850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca64850",
  null
  
)

export default component.exports